module.exports = __webpack_public_path__ + "media/customizations/parkvueontheplatte/logo-7e410156d633528300b180893a9d412a.png";